export interface PasswordRequirement {
  id: string;
  label: string;
  regex: RegExp;
  met: boolean;
}

export const getPasswordRequirements = (): PasswordRequirement[] => [
  {
    id: 'length',
    label: 'At least 12 characters',
    regex: /.{12,}/,
    met: false,
  },
  {
    id: 'uppercase',
    label: 'One uppercase letter',
    regex: /[A-Z]/,
    met: false,
  },
  {
    id: 'lowercase',
    label: 'One lowercase letter',
    regex: /[a-z]/,
    met: false,
  },
  {
    id: 'number',
    label: 'One number',
    regex: /\d/,
    met: false,
  },
  {
    id: 'special',
    label: 'One special character (!@#$%^&*)',
    regex: /[!@#$%^&*]/,
    met: false,
  },
];

export const validatePasswordRequirements = (password: string): PasswordRequirement[] => {
  const requirements = getPasswordRequirements();
  return requirements.map(req => ({
    ...req,
    met: req.regex.test(password),
  }));
};

export const checkPasswordsMatch = (password: string, confirmPassword: string): boolean => {
  return password === confirmPassword && password.length > 0;
};

export const areAllRequirementsMet = (requirements: PasswordRequirement[], passwordsMatch: boolean): boolean => {
  return requirements.every(req => req.met) && passwordsMatch;
};
